var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintdropdownicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_590_11858",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3525 20.3525V3.64745H3.64746V20.3525H20.3525Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_590_11858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3454 16.5016H18.3652C19.5307 16.5016 20.4753 15.557 20.4753 14.3915V10.1714C20.4753 9.0059 19.5307 8.06129 18.3652 8.06129H5.63448C4.46902 8.06129 3.52441 9.0059 3.52441 10.1714V14.3915C3.52441 15.557 4.46902 16.5016 5.63448 16.5016H6.65435",
    stroke: "#666666",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1896 13.688H5.81055",
    stroke: "#666666",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70933 20.4755H16.2903C16.8729 20.4755 17.3453 20.0031 17.3453 19.4205V13.6881H6.6543V19.4205C6.6543 20.0031 7.12667 20.4755 7.70933 20.4755Z",
    stroke: "#666666",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4062 15.9388H10.5928",
    stroke: "#666666",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4062 18.1895H10.5928",
    stroke: "#666666",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4986 10.3119H5.81055",
    stroke: "#666666",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76437 3.52451H15.2352C16.4006 3.52451 17.3453 4.46922 17.3453 5.63458V8.06116H6.6543V5.63458C6.6543 4.46922 7.59901 3.52451 8.76437 3.52451Z",
    stroke: "#666666",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintdropdownicon);
export default __webpack_public_path__ + "static/media/printdropdownicon.1c4b6b3cba8e35594acdae519239a4b7.svg";
export { ForwardRef as ReactComponent };